import breakpoints from "../../helpers/breakpoints";
const { md }                             = breakpoints;
const menuOpened                         = "opened";
const menuOpenedOnNav                    = "menu-opened";
const dropdownTopCssVar                  = "--main-menu-dropdown-top";
const cityNotificationTopCssVar          = "--current-city-notification-top";
const cityNotificationRightCssVar        = "--current-city-notification-right";
const screenLgPx                         = 1080;
const cityNotificationRightOffsetDesktop = 100; // px
const bodyLoginMenuOpenedClass           = "login-menu-opened";
const bodyLoginMenuClosedClass           = "login-menu-closed";
const bodyMainMenuOpenedClass            = "main-menu-opened";
const bodyMainMenuClosedClass            = "main-menu-closed";
const loginMenuClosingClass              = "login-menu--closing";
const userHeaderClosingClass             = "user-header--closing";
const loginMenuSlideDurationMs           = 450;
const loginMenuSlideDurationMobileMs     = 600;

let bodyScrollLockPosition  = 0;
let bodyScrollLockRestoring = false;
let bodyScrollLockActive    = false;

function isInsideScrollableOverlay(element) {
    return element && (element.closest(".js-login-menu") || element.closest(".main-menu"));
}

function preventBodyScroll(e) {
    if (!isInsideScrollableOverlay(e.target)) {
        e.preventDefault();
    }
}

function restoreBodyScrollPosition() {
    if (bodyScrollLockRestoring) {
        return;
    }

    bodyScrollLockRestoring = true;
    window.scrollTo(0, bodyScrollLockPosition);
    requestAnimationFrame(() => {
        bodyScrollLockRestoring = false;
    });
}

function lockBodyScroll() {
    if (bodyScrollLockActive) {
        bodyScrollLockPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        return;
    }

    bodyScrollLockActive   = true;
    bodyScrollLockPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    document.addEventListener("wheel", preventBodyScroll, { passive: false });
    document.addEventListener("touchmove", preventBodyScroll, { passive: false });
    window.addEventListener("scroll", restoreBodyScrollPosition, { passive: true });

    if (isHamburgerLayout()) {
        document.body.style.overflow = "hidden";
    }
}

function unlockBodyScrollInternal() {
    bodyScrollLockActive = false;
    document.removeEventListener("wheel", preventBodyScroll);
    document.removeEventListener("touchmove", preventBodyScroll);
    window.removeEventListener("scroll", restoreBodyScrollPosition);

    if (isHamburgerLayout()) {
        document.body.style.overflow = "";
    }
}

function isAnyOverlayMenuOpen() {
    const mainMenuOpen  = document.querySelector(".main-menu.opened");
    const loginMenuOpen = document.querySelector(".js-user-header.opened");

    return !!(mainMenuOpen || loginMenuOpen);
}

function unlockBodyScroll() {
    if (isAnyOverlayMenuOpen()) {
        return;
    }

    unlockBodyScrollInternal();
}

function isHamburgerLayout() {
    const togglers = document.querySelectorAll(".mobile-menu-toggler");

    if (togglers && togglers.length) {
        for (let i = 0; i < togglers.length; i++) {
            const toggler = togglers[i];
            const cs      = window.getComputedStyle(toggler);
            const hasBox  = (toggler.offsetWidth > 0 || toggler.offsetHeight > 0);

            if (cs.display !== "none" && cs.visibility !== "hidden" && hasBox) {
                return true;
            }
        }

        return window.innerWidth < screenLgPx;
    }

    return window.innerWidth < screenLgPx;
}

function isHoverCapable() {
    try {
        return window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    } catch (e) {
        return false;
    }
}

function isInstitutionalPath() {
    try {
        var path = (window.location && window.location.pathname) ? String(window.location.pathname) : "";

        return /\/(institucional|sobre-nos)(\/|$)/i.test(path);
    } catch (e) {
        return false;
    }
}

function normalizeBodyClassForInstitutional() {
    if (!document || !document.body) {
        return;
    }

    if (document.body.className === "null") {
        document.body.className = "";
    }

    if (isInstitutionalPath()) {
        document.body.classList.add("is-institutional-page");
    }
}

function setDropdownTopCssVar() {
    const navigation = document.querySelector(".navigation");

    if (!navigation) {
        return;
    }

    const rect      = navigation.getBoundingClientRect();
    const navHeight = Math.max(0, Math.round(rect.height));
    const bottom    = Math.round(rect.bottom);

    const topValue = bottom <= 0 ? "0px" : `${Math.max(navHeight, bottom)}px`;

}

function setCurrentCityNotificationTopCssVar() {
    const triggers = Array.from(document.querySelectorAll(".js-toggle-select-city"));

    if (!triggers.length) {
        return;
    }

    const visibleTrigger = triggers.find((el) => {
        const rects = el.getClientRects();

        if (!rects || rects.length === 0) {
            return false;
        }

        const cs = window.getComputedStyle(el);

        return cs.display !== "none" && cs.visibility !== "hidden";
    });

    if (!visibleTrigger) {
        return;
    }

    if (isHamburgerLayout()) {
        document.documentElement.style.removeProperty(cityNotificationTopCssVar);
        document.documentElement.style.removeProperty(cityNotificationRightCssVar);
        return;
    }

    const rect  = visibleTrigger.getBoundingClientRect();
    const top   = Math.max(0, Math.round(rect.bottom + 8));
    const right = Math.max(10, Math.round((window.innerWidth - rect.right) + cityNotificationRightOffsetDesktop));

    document.documentElement.style.setProperty(cityNotificationTopCssVar, `${top}px`);
    document.documentElement.style.setProperty(cityNotificationRightCssVar, `${right}px`);
}

function initializeDropdownTopCssVar() {
    let scheduled = false;

    const schedule = () => {
        if (scheduled) {
            return;
        }

        scheduled = true;
        window.requestAnimationFrame(() => {
            scheduled = false;
            setDropdownTopCssVar();
            setCurrentCityNotificationTopCssVar();
        });
    };

    schedule();
    $(window).on("resize", schedule);
    $(window).on("scroll", schedule);
}

function initializeLogoutBehavior() {
    const $logoutLink          = $(".js-logout");

    $logoutLink.on("click", function (e) {
        e.preventDefault();

        $.ajax({
            url: $logoutLink.attr("href"),
            type: "GET",
            success: function (response) {
                window.location.href = response.redirectUrl;
            },
            error: function (error) {
                console.log(error);
            }
        });
    });
}

function toggleHeaderNavigation() {
    if ($(".mobile-menu-toggler").is(":visible")) {
        const $navContainer     = $(".js-category-navigation");
        const $navListContainer = $("ul", $navContainer);

        $navContainer.toggleClass("collapsed");
        $navListContainer.css(
            "max-height",
            $navContainer.hasClass("collapsed") ? `${$navListContainer.prop("scrollHeight")}px` : 0
        );
    }
}

const initializeMenuToggleBehaviorOnMobile = () => {
    const menuToggler = $(".mobile-menu-toggler");
    const mainMenu    = $(".main-menu");
    const navigation  = $(".navigation");

    initializeLogoutBehavior();

    menuToggler.click(function () {
        $(this).toggleClass(menuOpened);
        const openModals = $(".current-city-notification__container:visible");

        if (openModals.length > 1) {
            $(openModals[0]).css("display", "none");
        }

        $(mainMenu).toggleClass(menuOpened);
        navigation.toggleClass(menuOpenedOnNav, $(mainMenu).hasClass(menuOpened));

        if (!$(mainMenu).hasClass(menuOpened)) {
            $(".categories, .categories__section__links, .categories__section__2Links", mainMenu).removeClass(menuOpened);
            $("[aria-expanded]", mainMenu).attr("aria-expanded", "false");
        }

        const isMenuOpen = $(mainMenu).hasClass(menuOpened);

        if (!isHamburgerLayout()) {
            document.body.style.overflow     = "";
            document.body.style.paddingRight = "";
        }

        if (isMenuOpen) {
            document.body.classList.remove(bodyMainMenuClosedClass);
            document.body.classList.add(bodyMainMenuOpenedClass);
            lockBodyScroll();
        } else {
            document.body.classList.remove(bodyMainMenuOpenedClass);
            document.body.classList.add(bodyMainMenuClosedClass);
            unlockBodyScroll();
        }

        const userHeaderWrapper = $(".js-user-header");

        if (userHeaderWrapper.hasClass(menuOpened)) {
            closeLoginMenuAndCleanBody();
        }
    });
};

const initializeMenuToggleBehavior = () => {
    const mainMenu                     = $(".main-menu");
    const menuSubCategoryTitleSelector = ".categories__section__subCategory";

    initializeLogoutBehavior();

    const setAriaExpanded = ($el, expanded) => {
        $el.attr("aria-expanded", expanded ? "true" : "false");
    };

    const resetNestedState = ($root) => {
        $(".categories__section__links, .categories__section__2Links", $root).removeClass(menuOpened);
        $("[aria-expanded]", $root).attr("aria-expanded", "false");
    };

    mainMenu.on("click", ".categories a", function (e) {
        const $a = $(this);

        const isSubmenuToggle = $a.is(menuSubCategoryTitleSelector) || $a.closest(menuSubCategoryTitleSelector).length > 0;

        if (isSubmenuToggle) {
            return;
        }

        e.stopPropagation();
    });
    mainMenu.on("click", ".main-menu__list__item__title", function (e) {
        const $title  = $(this);
        const $target = $(e.target);

        const isLinkClick      = $target.is("a") || $target.closest("a").length > 0;
        const isInsideDropdown = $target.closest(".categories").length > 0;

        if (isLinkClick && isInsideDropdown) {
            return;
        }

        const $menuItem   = $title.closest(".main-menu__list__item");
        const $categories = $menuItem.find(".categories").first();

        if (isHamburgerLayout()) {
            e.preventDefault();

            if ($categories.hasClass(menuOpened)) {
                return;
            }

            $categories.addClass(menuOpened);
            setAriaExpanded($title, true);
        } else {
            e.preventDefault();
            e.stopPropagation();
        }
    });

    mainMenu.on("click", ".categories > .categories__section__title, .categories__section__links > .categories__section__title, .categories__section__2Links > .categories__section__title", function (e) {
        if (!isHamburgerLayout()) { return; }

        e.preventDefault();
        e.stopPropagation();

        const $title  = $(this);
        const $parent = $title.parent();

        $parent.toggleClass(menuOpened);

        const isExpanded = $parent.hasClass(menuOpened);

        setAriaExpanded($title, isExpanded);

        if ($parent.hasClass("categories")) {
            const $parentMenuItemTitle = $title
                .closest(".main-menu__list__item")
                .find(".main-menu__list__item__title")
                .first();

            if ($parentMenuItemTitle.length) {
                setAriaExpanded($parentMenuItemTitle, isExpanded);
            }
        }

        if ($parent.hasClass("categories__section__links") || $parent.hasClass("categories__section__2Links")) {
            const $trigger = $parent.siblings(menuSubCategoryTitleSelector).first();

            if ($trigger.length) {
                setAriaExpanded($trigger, isExpanded);
            }
        }

        if (!isExpanded) {
            resetNestedState($parent);
        }
    });

    mainMenu.on("click", menuSubCategoryTitleSelector, function (e) {
        if (!isHamburgerLayout()) { return; }

        const $sub    = $(this);
        const $links  = $sub.siblings(".categories__section__links");
        const $links2 = $sub.siblings(".categories__section__2Links");

        if ($links.length === 0 && $links2.length === 0) { return; }

        e.preventDefault();
        e.stopPropagation();

        $links.toggleClass(menuOpened);
        $links2.toggleClass(menuOpened);

        const isExpanded = $links.hasClass(menuOpened) || $links2.hasClass(menuOpened);

        setAriaExpanded($sub, isExpanded);

        if (!isExpanded) {
            resetNestedState($links.add($links2));
        }
    });
};

const initializeCategoryNavToggleBehavior = () => {
    const $container = $(".js-category-navigation");

    if ($container.length === 0) { return; }

    $(".js-category-nav-toggle", $container).on("click", function () {
        toggleHeaderNavigation();
    });
};

const initializeCategoryNavScrollIntoViewBehavior = () => {
    const $container = $(".js-category-navigation");

    if ($container.length === 0) { return; }

    $(".js-anchor-link", $container).on("click", function () {
        const $clickedAnchorButton = $(this);
        const targetSectionID      = $clickedAnchorButton.data("target-section");
        const $targetSection       = $(`#${targetSectionID}`);

        if ($targetSection.length === 0) { return; }

        $targetSection[0].scrollIntoView({
            behavior: "smooth",
            block: "end"
        });

        toggleHeaderNavigation();
    });

};

const initializeCategoryNavPositioningOnMobile = () => {
    const currentWidth       = $(window).width();
    const $mobileCategoryNav = $(".js-category-navigation");
    const $targetContainer   = $(".js-category-navigation-container");

    if (currentWidth >= md || $mobileCategoryNav.length === 0) {
        $targetContainer.remove();
        return;
    }

    $mobileCategoryNav.detach().appendTo($targetContainer);
};

const loginHeaderIconClosedClass = "login-header__icon--closed";

function setLoginIconClosedState($icon) {
    const icons = $icon && $icon.length ? $icon : $(".js-login-header-icon");

    icons.each(function () {
        this.style.setProperty("background-color", "#ffffff", "important");
    });
}

function clearLoginIconInlineStyles($icon) {
    const icons = $icon && $icon.length ? $icon : $(".js-login-header-icon");

    icons.each(function () {
        this.style.removeProperty("background-color");
    });
}

function applyLoginIconClosedState() {
    const icons = document.querySelectorAll(".js-login-header-icon");

    icons.forEach(function (icon) {
        icon.classList.add(loginHeaderIconClosedClass);
        icon.setAttribute("data-login-icon-state", "closed");
        icon.style.setProperty("background-color", "#ffffff", "important");
    });
}

function clearLoginIconOpenState() {
    const icons = document.querySelectorAll(".js-login-header-icon");

    icons.forEach(function (icon) {
        icon.classList.remove(loginHeaderIconClosedClass);
        icon.removeAttribute("data-login-icon-state");
        icon.style.removeProperty("background-color");
    });
}

function closeLoginMenuAndCleanBody() {
    const loginSideMenu     = $(".js-login-menu");
    const userHeaderWrapper = $(".js-user-header");

    if (loginSideMenu.hasClass(loginMenuClosingClass)) {
        return;
    }

    let cleanupDone = false;

    const doCleanup = () => {
        if (cleanupDone) return;
        cleanupDone = true;

        const userLoginHeader = $(".js-login-header");
        const loginHeaderIcon = userLoginHeader.find(".js-login-header-icon");

        userHeaderWrapper.removeClass(menuOpened);
        userHeaderWrapper.removeClass(userHeaderClosingClass);
        loginSideMenu.removeClass(menuOpened);
        loginSideMenu.removeClass(loginMenuClosingClass);
        loginHeaderIcon.addClass(loginHeaderIconClosedClass);
        setLoginIconClosedState(loginHeaderIcon);
        userLoginHeader.attr("aria-expanded", "false");
        document.body.classList.remove(bodyLoginMenuOpenedClass);
        document.body.classList.add(bodyLoginMenuClosedClass);

        unlockBodyScroll();

        requestAnimationFrame(function () {
            applyLoginIconClosedState();
            requestAnimationFrame(applyLoginIconClosedState);
        });

        if (document.activeElement && document.activeElement.blur) {
            document.activeElement.blur();
        }
    };

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            userHeaderWrapper.addClass(userHeaderClosingClass);
            loginSideMenu.addClass(loginMenuClosingClass);

            const menuEl         = loginSideMenu[0];
            const onAnimationEnd = (e) => {
                if (e.target === menuEl && e.animationName && e.animationName.indexOf("slideOut") !== -1) {
                    menuEl.removeEventListener("animationend", onAnimationEnd);
                    doCleanup();
                }
            };

            menuEl.addEventListener("animationend", onAnimationEnd);

            const fallbackMs = isHamburgerLayout() ? loginMenuSlideDurationMobileMs : loginMenuSlideDurationMs;

            setTimeout(doCleanup, fallbackMs + 100);
        });
    });
}

const setOnClickToggleListenersForMenu = () => {
    const userLoginHeader   = $(".js-login-header");
    const userHeaderWrapper = $(".js-user-header");
    const loginSideMenu     = $(".js-login-menu");
    const mainMenu          = $(".main-menu");
    const navigation        = $(".navigation");

    if (!userHeaderWrapper.hasClass(menuOpened)) {
        document.body.classList.add(bodyLoginMenuClosedClass);
    }

    if (!mainMenu.hasClass(menuOpened)) {
        document.body.classList.add(bodyMainMenuClosedClass);
    }

    userLoginHeader.attr("aria-expanded", userHeaderWrapper.hasClass(menuOpened));

    const $loginIcon = userLoginHeader.find(".js-login-header-icon");

    $loginIcon.toggleClass(loginHeaderIconClosedClass, !userHeaderWrapper.hasClass(menuOpened));

    if (!userHeaderWrapper.hasClass(menuOpened)) {
        setLoginIconClosedState($loginIcon);
        requestAnimationFrame(applyLoginIconClosedState);
    } else {
        clearLoginIconInlineStyles($loginIcon);
    }

    userLoginHeader.on("click", function (e) {
        e.stopPropagation();
        const isOpening       = !userHeaderWrapper.hasClass(menuOpened);
        const loginHeaderIcon = userLoginHeader.find(".js-login-header-icon");

        if (isOpening) {
            userHeaderWrapper.addClass(menuOpened);
            loginSideMenu.addClass(menuOpened);
            loginHeaderIcon.removeClass(loginHeaderIconClosedClass);
            clearLoginIconInlineStyles(loginHeaderIcon);
            clearLoginIconOpenState();
        } else {
            closeLoginMenuAndCleanBody();
            userLoginHeader.attr("aria-expanded", "false");

            const menuToggler = $(".mobile-menu-toggler");
            const mainMenuRef = $(".main-menu");

            if (menuToggler.hasClass(menuOpened)) {
                menuToggler.removeClass(menuOpened);
                mainMenuRef.removeClass(menuOpened);
                navigation.removeClass(menuOpenedOnNav);
            }

            return;
        }

        userLoginHeader.attr("aria-expanded", userHeaderWrapper.hasClass(menuOpened));

        document.body.classList.remove(bodyLoginMenuClosedClass);
        document.body.classList.add(bodyLoginMenuOpenedClass);

        if (!isHamburgerLayout()) {
            document.body.style.overflow     = "";
            document.body.style.paddingRight = "";
        }

        lockBodyScroll();

        requestAnimationFrame(() => {
            setDropdownTopCssVar();
        });

        const menuToggler = $(".mobile-menu-toggler");
        const mainMenu    = $(".main-menu");

        if (menuToggler.hasClass(menuOpened)) {
            menuToggler.removeClass(menuOpened);
            mainMenu.removeClass(menuOpened);
            navigation.removeClass(menuOpenedOnNav);
        }
    });

    $(document).on("click", function (e) {
        if (!userHeaderWrapper.hasClass(menuOpened)) {
            return;
        }

        if ($(e.target).closest(".js-user-header").length || $(e.target).closest(".js-login-menu").length) {
            return;
        }

        closeLoginMenuAndCleanBody();
    });
};

const initializeStickyOnScrollUpBehavior = () => {
    const $stickyElements = $(".js-sticky-on-scroll-up");

    if ($stickyElements.length === 0) {
        return;
    }

    $stickyElements.each(function () {
        const $stickyElement  = $(this);

        initializeStickyBehavior($stickyElement);
    });
};

const initializeStickyBehavior = ($stickyElement) => {
    const headerFloatingAnchor = $("#headerFloatingAnchor");
    let prevScrollPosition     = window.scrollY;
    let isIntersecting         = false;

    $(window).on("scroll", function () {
        const currentScrollPosition = window.scrollY;
        const isCategoryNavigation  = $stickyElement.hasClass("pd-category-navigation");

        const onScrollUpPosition = isCategoryNavigation
            ? `${headerFloatingAnchor.height()}px`
            : "0px";

        if (prevScrollPosition > currentScrollPosition) {
            $stickyElement.css({ top: onScrollUpPosition});

            if (!isIntersecting) {
                $(".js-cart-summary").css({ top: "110px" });
                $stickyElement.addClass("floating");
            } else {
                $(".js-cart-summary").css({ top: "34px" });
                $stickyElement.removeClass("floating");
            }
        } else {
            if (!isIntersecting) {
                $(".js-cart-summary").css({ top: "34px" });
                $stickyElement.css({ top: `-${headerFloatingAnchor.height()}px` });
            }
        }

        prevScrollPosition = currentScrollPosition;
    });

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                isIntersecting = true;
                $stickyElement.removeClass("floating");
            } else {
                isIntersecting = false;
                $stickyElement.addClass("floating");
            }
        });
    });

    observer.observe(headerFloatingAnchor[0]);
};

const getContainingBlockRect = (el) => {
    let parent = el.parentElement;

    while (parent && parent !== document.documentElement) {
        const cs = window.getComputedStyle(parent);

        if (
            cs.transform !== "none" ||
            cs.filter !== "none" ||
            cs.willChange === "transform" ||
            cs.perspective !== "none"
        ) {
            return parent.getBoundingClientRect();
        }

        parent = parent.parentElement;
    }

    // No transformed ancestor — fixed is truly relative to the viewport
    return { left: 0, top: 0, right: window.innerWidth, bottom: window.innerHeight, width: window.innerWidth, height: window.innerHeight };
};

const updateCategoriesArrowPosition = ($menuItem, $categories) => {
    const categoriesEl = $categories[0];

    if (!categoriesEl) {
        return;
    }

    categoriesEl.style.removeProperty("left");
    categoriesEl.style.removeProperty("right");
    categoriesEl.style.removeProperty("max-width");

    const itemRect     = $menuItem[0].getBoundingClientRect();
    let categoriesRect = categoriesEl.getBoundingClientRect();
    const safetyMargin = 8;

    const cbRect = getContainingBlockRect(categoriesEl);

    if (categoriesRect.right > window.innerWidth - safetyMargin) {
        const cssRight = cbRect.right - (window.innerWidth - safetyMargin);

        categoriesEl.style.setProperty("right", `${Math.round(cssRight)}px`, "important");
        categoriesEl.style.setProperty("left", "auto", "important");

        categoriesRect = categoriesEl.getBoundingClientRect();
    }

    if (categoriesRect.left < safetyMargin) {
        const availableWidth = window.innerWidth - 2 * safetyMargin;

        if (availableWidth <= categoriesRect.width) {
            categoriesEl.style.setProperty("max-width", `${Math.round(availableWidth - 20)}px`, "important");
        }

        categoriesRect = categoriesEl.getBoundingClientRect();

        categoriesEl.style.setProperty("left", "auto", "important");
        categoriesEl.style.setProperty("right", `${Math.round(categoriesRect.left)}px`, "important");

        categoriesRect = categoriesEl.getBoundingClientRect();
    }

    const arrowWidth = 16;
    const minLeft    = 8;
    let arrowLeft    = (itemRect.left + itemRect.width / 2) - categoriesRect.left - arrowWidth / 2;
    const maxLeft    = categoriesRect.width - arrowWidth - minLeft;

    arrowLeft = Math.max(minLeft, Math.min(arrowLeft, maxLeft));

    categoriesEl.style.setProperty("--categories-arrow-left", `${Math.round(arrowLeft)}px`);
};

const initializeMenuHoverBehavior = () => {
    const mainMenu  = $(".main-menu");
    const menuItems = mainMenu.find(".main-menu__list__item");
    let hoverTimeout;

    menuItems.each(function () {
        const $menuItem   = $(this);
        const $categories = $menuItem.find(".categories");

        $menuItem.on("focusin", function () {
            menuItems.trigger("blur");
            $(this).trigger("mouseenter");
        });

        $menuItem.on("mouseenter", function () {
            if (isHamburgerLayout() || !isHoverCapable()) {
                return;
            }

            setDropdownTopCssVar();
            clearTimeout(hoverTimeout);
            $categories.addClass("menu-hover-active");
            $menuItem.addClass("menu-item-hover-active");
            updateCategoriesArrowPosition($menuItem, $categories);

            menuItems.not($menuItem).each(function () {
                $(this).find(".categories").removeClass("menu-hover-active");
                $(this).removeClass("menu-item-hover-active");
            });
        });

        $menuItem.on("mouseleave", function (e) {
            if (isHamburgerLayout() || !isHoverCapable()) {
                return;
            }

            const relatedTarget = e.relatedTarget;

            if (relatedTarget && ($categories.is(relatedTarget) || $categories.has(relatedTarget).length > 0 || $(relatedTarget).closest(".categories").length > 0)) {
                return;
            }

            hoverTimeout = setTimeout(() => {
                if (!$menuItem.is(":hover") && !$categories.is(":hover") && $categories.find(":hover").length === 0) {
                    $categories.removeClass("menu-hover-active");
                    $menuItem.removeClass("menu-item-hover-active");
                }
            }, 150);
        });

        $categories.on("mouseenter", function () {
            if (isHamburgerLayout() || !isHoverCapable()) {
                return;
            }



            clearTimeout(hoverTimeout);
            $(this).addClass("menu-hover-active");
            $menuItem.addClass("menu-item-hover-active");
        });

        $categories.on("mouseleave", function (e) {
            if (isHamburgerLayout() || !isHoverCapable()) {
                return;
            }

            const relatedTarget = e.relatedTarget;

            if (relatedTarget && ($menuItem.is(relatedTarget) || $menuItem.has(relatedTarget).length > 0 || $(relatedTarget).closest(".main-menu__list__item").is($menuItem).length > 0)) {
                return;
            }

            hoverTimeout = setTimeout(() => {
                if (!$menuItem.is(":hover") && !$categories.is(":hover") && $categories.find(":hover").length === 0) {
                    $(this).removeClass("menu-hover-active");
                    $menuItem.removeClass("menu-item-hover-active");
                }
            }, 150);
        });
    });
};

const initializeMenu = () => {
    normalizeBodyClassForInstitutional();
    initializeDropdownTopCssVar();
    initializeMenuToggleBehaviorOnMobile();
    initializeMenuToggleBehavior();
    initializeCategoryNavToggleBehavior();
    initializeCategoryNavPositioningOnMobile();
    initializeMenuHoverBehavior();

    setOnClickToggleListenersForMenu();
    initializeCategoryNavScrollIntoViewBehavior();
    initializeStickyOnScrollUpBehavior();
};

export default initializeMenu;
